import React from "react";
import Loader from "@/components/loaders/Loader";
import { useFetchToken } from "@/hooks/useFetchToken";

interface AuthorizationProviderProps {
  children?: React.ReactNode;
}

const AuthorizationProvider: React.FC<AuthorizationProviderProps> = ({
  children,
}) => {
  const { isLoading } = useFetchToken();

  if (isLoading) return <Loader />;

  return <>{children}</>;
};

export default AuthorizationProvider;
